import * as React from 'react';
import { FlexyTabs, TabStructure } from '@europrocurement/flexy-components';
import { Card } from '@mui/material';
import GrilleTarifaire from '@europrocurement/l2d-modules/src/modules/GrilleTarifaire/page/GrilleTarifaire';
import { SUB_TAB_ROUTER_PARAMETER } from '../../../constants/paths';
import FormalitiesSettings from './Formalities/FormalitiesSettings';
// import FormalitiesNotifications from './Formalities/FormalitiesNotifications';
import { PrescriberTabProps } from './types';

const Formalitie: React.FunctionComponent<PrescriberTabProps> = function (props) {
    const { prescriber } = props;
    const TABS: Array<TabStructure> = [
        {
            tabName: 'parametrage',
            tabTitle: 'Paramétrage',
            tabPanel: <FormalitiesSettings prescriberId={`${prescriber.id}`} />,
        },
        // {
        //     tabName: 'notification',
        //     tabTitle: 'Notifications',
        //     tabPanel: <FormalitiesNotifications />,
        // },
        {
            tabName: 'grilletarifaire',
            tabTitle: 'Grille Tarifaire',
            tabPanel: (
                <GrilleTarifaire
                    showOrigineFilter
                    showTTC
                    showAction
                    showOffer={false}
                    showNumberCatalogue={false}
                    showElement
                    showDate
                    surchargeHonoraire
                    surchargeCatalogue={false}
                    surchargePackage={false}
                    surchargeAL={false}
                    surchargeFD={false}
                    waitPrescripteur
                    selectedPrescriberId={prescriber.id}
                    showFilter={false}
                />
            ),
        },
    ];

    return (
        <Card sx={{ paddingTop: 0, marginLeft: 0, marginRight: 0, marginTop: '5px' }}>
            <FlexyTabs
                orientation="horizontal"
                sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '15px' }}
                tabs={TABS}
                scrollbar={false}
                routerParameterName={SUB_TAB_ROUTER_PARAMETER}
            />
        </Card>
    );
};

export default Formalitie;
